import React from 'react';

const Expertise = React.lazy(() => import('pages/Expertise/Expertise'));
const ExpertiseAdd = React.lazy(() => import('pages/Expertise/ExpertiseAdd'));
const ExpertiseEdit = React.lazy(() => import('pages/Expertise/ExpertiseEdit'));
const ExpertiseDetail = React.lazy(() => import('pages/Expertise/ExpertiseDetail'));

const expertiseRoutes = [
  {
    path: '/expertise',
    exact: true,
    name: 'Danh sách chuyên môn',
    function: 'EXPERTISE_VIEW',
    component: Expertise,
  },
  {
    path: '/expertise/add',
    exact: true,
    name: 'Thêm mới chuyên môn',
    function: 'EXPERTISE_ADD',
    component: ExpertiseAdd,
  },
  {
    path: '/expertise/detail/:id',
    exact: true,
    name: 'Chi tiết chuyên môn',
    function: 'EXPERTISE_VIEW',
    component: ExpertiseDetail,
  },
  {
    path: '/expertise/edit/:id',
    exact: true,
    name: 'Chỉnh sửa chuyên môn',
    function: 'EXPERTISE_EDIT',
    component: ExpertiseEdit,
  },
];

export default expertiseRoutes;
